import { Component, Inject, ViewChild } from '@angular/core';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatorService } from '../../../../services/translator_service';
import { ResponsiveService } from '../../../../services/responsive.service';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { PaginationComponent } from '../../../pagination/pagination.component';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ApiService } from '../../../../web-services/api/api.service';
import { ApiStore } from '../../../../web-services/api/api.store';
import _ from 'lodash';
import { MatSelectModule } from '@angular/material/select';
import { ApiQuery } from '../../../../web-services/api/api.query';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../../../custom-snackbar/custom-snackbar.component';
import { SnackbarComponent } from '../../../snackbar/snackbar.component';

@Component({
  selector: 'app-delete-events-modal',
  standalone: true,
  imports: [TranslateModule, RTLDivDirectiveDirective,CommonModule,MatTableModule,MatSortModule,PaginationComponent,
    FormsModule,ReactiveFormsModule,MatFormFieldModule,MatInputModule,MatSelectModule],
  templateUrl: './delete-events-modal.component.html',
  styleUrl: './delete-events-modal.component.scss'
})
export class DeleteEventsModalComponent {
  currentLang;
  translationsObj;
  isMobile: Boolean;
  startIndexTableData = 0;
  endIndexTableData = 4;
  filteredData:Array<object> = [];
	@ViewChild(MatSort,{static: false}) sort: MatSort;
  dataSource = new MatTableDataSource<any>();
  binCollectionData:Array<object> = [];
  displayedColumns = ['name','clearing','address','reason'];
  collectionReasonTypes:Array<object> = [];

  constructor(private translator: TranslatorService,private dialogRef: MatDialogRef<DeleteEventsModalComponent>, 
    private responsiveService: ResponsiveService,@Inject(MAT_DIALOG_DATA) public data: any,public fb: FormBuilder,
    private apiService:ApiService,private apiStore:ApiStore,private apiQuery:ApiQuery,private snackBar: MatSnackBar) {
      this.dialogRef.disableClose = true;
      this.translator.currentLangEmitter$
      .subscribe(async value=>{						
        this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
        this.currentLang = value;	
      });
  }

  ngOnInit() {       
    this.onResize();
    this.responsiveService.checkWidth();
		this.binCollectionData = this.data.items;
		const hasValidItems = this.binCollectionData.some((item: any) => item.is_approved_suspected_as_collection_event != false);
		if (!hasValidItems) {
			this.displayedColumns = this.displayedColumns.filter(col => col != 'reason');
		}
		this.updateTableData();

    this.apiQuery.collectionReasonTypes$.subscribe((types) => {
      if(types.length == 0){return;}      
      this.collectionReasonTypes = types;
    });
  }

  onResize() {
    this.responsiveService.getMobileStatus().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  setElementReason(reason: string, element: any) {
    element.suspected_collections_reason_id = reason['suspected_collections_reason_id'];
    element.suspected_collections_reason_name = reason['suspected_collections_reason_name'];
    element.suspected_collections_reason_name_hebrew = reason['suspected_collections_reason_name_hebrew'];
  }

  closeModal = () => {
    this.dialogRef.close();
  }

  private runBulkCollectionUpdate(requestBody: any, afterVerify: () => void) {
    this.apiService.GenerateCollectionUpdateToken().subscribe({
      next: (tokenResponse: any) => {
        const token = tokenResponse?.token ?? 0;
        const bodyWithToken = { ...requestBody, token };
        this.apiService.insertCollectionParams(bodyWithToken).subscribe({
          next: (response: any) => {
            this.apiService.VerifyCollectionUpdateTaskStatusByToken({ token }).subscribe({
              next: (statusResponse: any) => {
                // Completed only if every element finished executing; otherwise failed.
                const statusList = statusResponse?.collectionUpdateTaskStatus?.collectionDataUpdateStatus || [];
                const allFinished = statusList.every((item: any) => item.is_executed == 1 && item.is_finished == 1);
                if (allFinished) {
                  this.openResultSnackbar('completed');
                } else {
                  const failedItems = statusList.filter((item: any) => !(item.is_executed == 1 && item.is_finished == 1));
                  this.openResultSnackbar('failed', failedItems);
                }
                afterVerify();
              },
              error: (err) => {
                console.error('Failed to verify collection update task status:', err);
                this.openResultSnackbar('failed');
                afterVerify();
              }
            });
          },
          error: (err) => {
            console.error('Failed to insert collection params:', err);
            this.openResultSnackbar('failed');
          }
        });
      },
      error: (err) => {
        console.error('Failed to generate collection update token:', err);
        this.openResultSnackbar('failed');
      }
    });
  }

  // Opens the shared SnackbarComponent showing ONLY the final result
  // (completed / failed with a toggle + details) - no waiting state.
  private openResultSnackbar(result: 'completed' | 'failed', failedItems: any[] = []) {
    // Pass the raw failed items; the snackbar template renders each one's status
    // (executed/finished flags) from translations - no display strings in the TS.
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: { popup: 'collectionResult', result: result, action: 'delete', error_messages: failedItems || [] },
      panelClass: 'custom-snackbar-class'
    });
  }

  applyChanges = () => {
    let undo_clicked = false;
    const snackBarRef = this.snackBar.openFromComponent(CustomSnackbarComponent,
		  {
        data: {events: this.data.items, action: 'delete'},
        panelClass: 'custom-toast-class',
        horizontalPosition: this.currentLang != 'iw' ? 'left' : 'right',
        verticalPosition: 'bottom',
        duration: 5000
		  }		
		);

    snackBarRef.onAction().subscribe(() => {
      undo_clicked = true;
      return;
    });

    snackBarRef.afterDismissed().subscribe(info => {
      if (!info.dismissedByAction) {
        if(!undo_clicked){
          let insertRequest = {
            collection_status: 3,
          };
      
          let collectionsIDs = [];
          let transactionsInfo = [];
          _.each(this.data.items, (item) => {
            if (item.is_approved_suspected_as_collection_event == false && (item.collection_id == 0 || item.collection_id == null)) {
              transactionsInfo.push({ transaction_id: item.transaction_id, after_collection_transaction_id: item.after_collection_transaction_id });
            } else {
              collectionsIDs.push([Number(item.collection_id), Number(item.suspected_collections_reason_id)]);
            }
          });

          if (transactionsInfo.length > 0) {
            let transactionsInfoRequest = {
              transactions_info: transactionsInfo,
              collection_status: 3
            };
            this.runBulkCollectionUpdate(transactionsInfoRequest, () => {
              let request = {
                site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
                start_date : sessionStorage.getItem("collectionsMinDate"),
                end_date : sessionStorage.getItem("collectionsMaxDate")
              }
              let removedCollectionsStatsRequest = {
                site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
                start_date : sessionStorage.getItem("collectionsMinDate"),
                end_date : sessionStorage.getItem("collectionsMaxDate")
              }
              this.apiStore.update({ allCollectionsStats: [] });
              this.apiStore.update({ collectionsStatsInCollections: [] });
              this.apiService.getfilteredBinsCollectionsStats(request, 5, JSON.parse(sessionStorage.getItem("chosenSites")));
              this.apiService.RemovedSuspectedCollections(removedCollectionsStatsRequest);
              this.apiService.getUnApprovedAndDeletedSuspectedAsCollectionEvents(removedCollectionsStatsRequest);
            });
          }

          if (collectionsIDs.length > 0) {
            insertRequest["collection_id_list"] = collectionsIDs;
            this.runBulkCollectionUpdate(insertRequest, () => {
              let request = {
                site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
                start_date : sessionStorage.getItem("collectionsMinDate"),
                end_date : sessionStorage.getItem("collectionsMaxDate")
              }
              let removedCollectionsStatsRequest = {
                site_id_list : JSON.parse(sessionStorage.getItem("chosenSites")).filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
                start_date : sessionStorage.getItem("collectionsMinDate"),
                end_date : sessionStorage.getItem("collectionsMaxDate")
              }
              this.apiStore.update({ allCollectionsStats: [] });
              this.apiStore.update({ collectionsStatsInCollections: [] });
              this.apiService.getfilteredBinsCollectionsStats(request, 5, JSON.parse(sessionStorage.getItem("chosenSites")));
              this.apiService.RemovedSuspectedCollections(removedCollectionsStatsRequest);
              this.apiService.getUnApprovedAndDeletedSuspectedAsCollectionEvents(removedCollectionsStatsRequest);
            });
          }
        }
      }
    });
    this.closeModal();
  }

  private updateTableData(): void {
    const tableData = [];
    const tempSearch = new MatTableDataSource<any>(this.binCollectionData || []);
    this.filteredData = tempSearch.filteredData;
    for (let index = this.startIndexTableData; index <= this.endIndexTableData; index++) {
      if (tempSearch.filteredData[index]) {
        tableData.push(tempSearch.filteredData[index]);
      }
    }
    this.dataSource = tableData.length > 0 ? new MatTableDataSource<any>(tableData) : new MatTableDataSource<any>([]);		
  }

  sortData(sort: Sort) {    
    const data = this.binCollectionData.slice();    
		if (!sort.active || sort.direction === '') {
			this.binCollectionData = data;
			this.updateTableData();
			return;
		}
		this.binCollectionData = data.sort((a, b) => {
			const isAsc = sort.direction === 'asc';
			return sort.active ? this.compare(a[sort.active], b[sort.active], isAsc) : 0;
		});
		this.updateTableData();
  }

  compare(a, b, isAsc) {
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onPageChange = (dataTableIndexes: any) => {
		this.startIndexTableData = dataTableIndexes.startIndex;
		this.endIndexTableData = dataTableIndexes.endIndex;
		this.updateTableData();
  }
}
